// Downloads page: the Unlimited-version card stays visible to everyone, but its
// download button starts in a "gated" state (Subscribe to download, opens Portal
// signup) and only unlocks to the real download link once /members/api/member/
// confirms an active paid/comped member session.
(function () {
    function unlock(btn) {
        var url = btn.getAttribute('data-download-url');
        var label = btn.getAttribute('data-unlocked-text') || 'Download';
        if (!url) return;
        btn.textContent = label;
        btn.setAttribute('href', url);
        btn.removeAttribute('data-portal');
        btn.classList.add('is-unlocked');
    }

    function init() {
        var btn = document.querySelector('.markupeditor-gated-download');
        if (!btn) return;

        fetch('/members/api/member/', {credentials: 'same-origin'})
            .then(function (res) {
                return res.status === 200 ? res.json() : null;
            })
            .then(function (member) {
                var isPaid = !!member && (member.status === 'paid' || member.status === 'comped');
                if (isPaid) unlock(btn);
            })
            .catch(function () {});
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
